import React from 'react'
import { ServiceGoto } from './serviceGoto'

const ServiceGotoParent = () => {
    return (
        <ServiceGoto />
    )
}
export default ServiceGotoParent